export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "ar-AE": {
        "noData": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["لا توجد بيانات لعرض"])}
        },
        "company": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الرجاء تحديد شركة"])}
        },
        "noMatch": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["لا توجد بيانات لعرض!"])}
        }
      },
      "ar-EG": {
        "noData": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["لا توجد بيانات لعرض"])}
        },
        "company": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الرجاء تحديد شركة"])}
        },
        "noMatch": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["لا توجد بيانات لعرض!"])}
        }
      },
      "ar-SA": {
        "noData": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["لا توجد بيانات لعرض"])}
        },
        "company": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["الرجاء تحديد شركة"])}
        },
        "noMatch": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["لا توجد بيانات لعرض!"])}
        }
      },
      "el-GR": {
        "noData": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Δεν υπάρχουν δεδομένα προς εμφάνιση!"])}
        },
        "company": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Επιλέξτε εταιρεία"])}
        },
        "noMatch": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Δεν υπάρχουν δεδομένα προς εμφάνιση!"])}
        }
      },
      "el-CY": {
        "noData": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Δεν υπάρχουν δεδομένα προς εμφάνιση!"])}
        },
        "company": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Επιλέξτε εταιρεία"])}
        },
        "noMatch": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Δεν υπάρχουν δεδομένα προς εμφάνιση!"])}
        }
      },
      "de-DE": {
        "noData": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Keine Daten zum Anzeigen"])}
        },
        "company": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unternehmen auswählen"])}
        },
        "noMatch": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Keine Daten zum Anzeigen!"])}
        }
      },
      "de-AT": {
        "noData": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Keine Daten zum Anzeigen"])}
        },
        "company": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unternehmen auswählen"])}
        },
        "noMatch": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Keine Daten zum Anzeigen!"])}
        }
      },
      "de-CH": {
        "noData": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Keine Daten zum Anzeigen"])}
        },
        "company": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unternehmen auswählen"])}
        },
        "noMatch": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Keine Daten zum Anzeigen!"])}
        }
      },
      "en-US": {
        "noData": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No data to display"])}
        },
        "company": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Select a company"])}
        },
        "noMatch": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No data to display!"])}
        }
      },
      "en-GB": {
        "noData": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No data to display"])}
        },
        "company": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Select a company"])}
        },
        "noMatch": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No data to display!"])}
        }
      },
      "it-IT": {
        "noData": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nessun dato da visualizzare!"])}
        },
        "company": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Seleziona un'azienda"])}
        },
        "noMatch": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nessun dato da visualizzare!"])}
        }
      },
      "fr-FR": {
        "noData": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aucune donnée à afficher!"])}
        },
        "company": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Veuillez sélectionner une entreprise"])}
        },
        "noMatch": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aucune donnée à afficher!"])}
        }
      },
      "es-ES": {
        "noData": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["¡No hay información para mostrar!"])}
        },
        "company": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Seleccione una empresa"])}
        },
        "noMatch": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["¡No hay información para mostrar!"])}
        }
      },
      "pl-PL": {
        "noData": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Brak danych do wyświetlenia!"])}
        },
        "company": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Wybierz firmę"])}
        },
        "noMatch": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Brak danych do wyświetlenia!"])}
        }
      },
      "nl-NL": {
        "noData": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Geen gegevens om weer te geven!"])}
        },
        "company": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Selecteer een bedrijf"])}
        },
        "noMatch": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Geen gegevens om weer te geven!"])}
        }
      },
      "bg-BG": {
        "noData": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Няма данни за показване!"])}
        },
        "company": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Моля, изберете фирма"])}
        },
        "noMatch": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Няма данни за показване!"])}
        }
      },
      "bs-BA": {
        "noData": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nema podataka za prikaz!"])}
        },
        "company": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Molimo odaberite kompaniju"])}
        },
        "noMatch": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nema podataka za prikaz!"])}
        }
      },
      "da-DK": {
        "noData": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ingen data at vise!"])}
        },
        "company": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vælg et firma"])}
        },
        "noMatch": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ingen data at vise!"])}
        }
      },
      "et-EE": {
        "noData": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pole andmeid, mida kuvada!"])}
        },
        "company": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Valige ettevõte"])}
        },
        "noMatch": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pole andmeid, mida kuvada!"])}
        }
      },
      "fi-FI": {
        "noData": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ei näytettäviä tietoja!"])}
        },
        "company": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Valitse yritys"])}
        },
        "noMatch": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ei näytettäviä tietoja!"])}
        }
      },
      "he-IL": {
        "noData": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["אין נתונים להצגה!"])}
        },
        "company": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["אנא בחר חברה"])}
        },
        "noMatch": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["אין נתונים להצגה!"])}
        }
      },
      "ga-IE": {
        "noData": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gan aon sonraí le taispeáint!"])}
        },
        "company": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Roghnaigh cuideachta le do thoil"])}
        },
        "noMatch": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gan aon sonraí le taispeáint!"])}
        }
      },
      "ja-JP": {
        "noData": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["表示するデータがありません！"])}
        },
        "company": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["会社を選択してください"])}
        },
        "noMatch": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["表示するデータがありません！"])}
        }
      },
      "hr-HR": {
        "noData": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nema podataka za prikaz!"])}
        },
        "company": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Odaberite tvrtku"])}
        },
        "noMatch": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nema podataka za prikaz!"])}
        }
      },
      "lv-LV": {
        "noData": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nav datu, ko parādīt!"])}
        },
        "company": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lūdzu, izvēlieties uzņēmumu"])}
        },
        "noMatch": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nav datu, ko parādīt!"])}
        }
      },
      "lt-LT": {
        "noData": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nėra rodomų duomenų!"])}
        },
        "company": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pasirinkite įmonę"])}
        },
        "noMatch": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nėra rodomų duomenų!"])}
        }
      },
      "pt-PT": {
        "noData": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sem dados para exibir!"])}
        },
        "company": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Selecione uma empresa"])}
        },
        "noMatch": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sem dados para exibir!"])}
        }
      },
      "ro-RO": {
        "noData": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nu sunt date de afișat!"])}
        },
        "company": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vă rugăm să selectați o companie"])}
        },
        "noMatch": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nu sunt date de afișat!"])}
        }
      },
      "ru-RU": {
        "noData": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Нет данных для отображения!"])}
        },
        "company": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Пожалуйста, выберите компанию"])}
        },
        "noMatch": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Нет данных для отображения!"])}
        }
      },
      "sv-SE": {
        "noData": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ingen data att visa!"])}
        },
        "company": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Välj ett företag"])}
        },
        "noMatch": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ingen data att visa!"])}
        }
      },
      "sk-SK": {
        "noData": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Žiadne údaje na zobrazenie!"])}
        },
        "company": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vyberte spoločnosť"])}
        },
        "noMatch": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Žiadne údaje na zobrazenie!"])}
        }
      },
      "cs-CZ": {
        "noData": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Žádná data k zobrazení!"])}
        },
        "company": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vyberte společnost"])}
        },
        "noMatch": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Žádná data k zobrazení!"])}
        }
      },
      "hu-HU": {
        "noData": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nincs megjeleníthető adat!"])}
        },
        "company": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Válasszon egy vállalatot"])}
        },
        "noMatch": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nincs megjeleníthető adat!"])}
        }
      },
      "fr-BE": {
        "noData": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aucune donnée à afficher!"])}
        },
        "company": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Veuillez sélectionner une entreprise"])}
        },
        "noMatch": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aucune donnée à afficher!"])}
        }
      },
      "fr-LU": {
        "noData": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aucune donnée à afficher!"])}
        },
        "company": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Veuillez sélectionner une entreprise"])}
        },
        "noMatch": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aucune donnée à afficher!"])}
        }
      },
      "mt-MT": {
        "noData": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["L-ebda dejta li trid turi"])}
        },
        "company": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Jekk jogħġbok agħżel kumpanija"])}
        },
        "noMatch": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["L-ebda dejta li trid turi"])}
        }
      },
      "sl-SI": {
        "noData": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ni podatkov za prikaz!"])}
        },
        "company": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Izberite podjetje"])}
        },
        "noMatch": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ni podatkov za prikaz!"])}
        }
      },
      "tr-TR": {
        "noData": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gösterilecek bilgi yok!"])}
        },
        "company": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lütfen bir şirket seçin"])}
        },
        "noMatch": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gösterilecek bilgi yok!"])}
        }
      },
      "tr-CY": {
        "noData": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gösterilecek bilgi yok!"])}
        },
        "company": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Lütfen bir şirket seçin"])}
        },
        "noMatch": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gösterilecek bilgi yok!"])}
        }
      },
      "uk-UA": {
        "noData": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Немає даних для відображення"])}
        },
        "company": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Виберіть компанію"])}
        },
        "noMatch": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Немає даних для відображення"])}
        }
      },
      "zh-CN": {
        "noData": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["没有数据显示！"])}
        },
        "company": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["请选择公司"])}
        },
        "noMatch": {
          "label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["没有数据显示！"])}
        }
      }
    }
  })
}
